import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberFormat',
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) {
      return '-';
    }

    if (value >= 1_000_000) {
      // Format millions
      return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 1_000) {
      // Format thousands
      return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    } else {
      // Numbers below 1,000
      return value.toString();
    }
  }
}
